import { useCallback, useEffect, useState } from 'react';
import type { ExchangeRate } from '../models/ExchangeRate';
import { exchangeRateService } from '../services/dataverse/exchangeRateService';

export const useExchangeRate = () => {
  const [rates, setRates] = useState<ExchangeRate[]>([]);
  const [currentRate, setCurrentRate] = useState<ExchangeRate | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const loadRates = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const [history, current] = await Promise.all([exchangeRateService.list(), exchangeRateService.getCurrent()]);
      setRates(history);
      setCurrentRate(current);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Unable to load exchange rates.');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { void loadRates(); }, [loadRates]);

  const createCurrentRate = useCallback(async (rate: number, effectiveFrom: string, notes?: string) => {
    const created = await exchangeRateService.createCurrent(rate, effectiveFrom, notes);
    await loadRates();
    return created;
  }, [loadRates]);

  return { rates, currentRate, loading, error, reload: loadRates, createCurrentRate };
};
